/**
 * 解析字典 value：兼容 JSON 字符串、已解析对象、多层字符串嵌套
 */
export function parseDictValue(raw) {
  if (raw == null || raw === '') return null
  if (typeof raw === 'object' && !Array.isArray(raw)) return raw

  if (typeof raw !== 'string') return null

  let current = raw.trim()
  if (!current) return null

  try {
    let parsed = JSON.parse(current)
    while (typeof parsed === 'string') {
      const next = parsed.trim()
      if (!next) break
      parsed = JSON.parse(next)
    }
    return parsed
  } catch {
    return null
  }
}
